export default __webpack_public_path__ + "resources/icons/d432-acc0.png";